import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { formatAuto } from '../global/formatter'
import HidrateCard from '../HidrateCard'

const TotalBottlesSaved = ({ totalWater, units }) => {
  return (
    <HidrateCard>
      <div className='text-left'>
        <h3 className='text-xl font-bold mb-2.5 text-black'>Total Bottles Saved</h3>
        <p className='text-5xl font-bold text-black mb-5'>
          {Math.round(totalWater / 500).toLocaleString()}
        </p>
      </div>
    </HidrateCard>
  )
}

const TotalCarbonSaved = ({ totalWater }) => {
  const carbonSaved = totalWater * 0.1646
  const roundedCarbonSaved = Math.round(carbonSaved)

  const treesEquivalent = (carbonSaved / 21772).toFixed(2)
  const kmNotDriven = Math.round(carbonSaved / 192).toLocaleString()
  const phoneCharges = Math.round(carbonSaved / 6).toLocaleString()
  const lightBulbHours = Math.round(carbonSaved / 4).toLocaleString()

  const facts = [
    `planting ${treesEquivalent} trees`,
    `avoiding ${kmNotDriven} km of driving`,
    `charging your phone ${phoneCharges} times`,
    `using an LED bulb for ${lightBulbHours} hours`
  ]

  const [factIndex, setFactIndex] = useState(0)

  // Cycle fun facts every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setFactIndex(prev => (prev + 1) % facts.length)
    }, 4000)

    return () => clearInterval(interval)
  }, [facts.length])

  return (
    <HidrateCard>
      <div className='text-left'>
        <h3 className='text-xl font-bold mb-2.5 text-black'>Total Carbon Saved</h3>

        <p className='text-5xl font-bold text-black mb-5'>
          {roundedCarbonSaved.toLocaleString()}g
        </p>

        <p className='text-xl text-gray-700 mt-2 transition-opacity duration-500 ease-in-out'>
          That’s like {facts[factIndex]}!
        </p>
      </div>
    </HidrateCard>
  )
}

TotalBottlesSaved.propTypes = {
  totalWater: PropTypes.number.isRequired,
  units: PropTypes.any
}

TotalCarbonSaved.propTypes = {
  totalWater: PropTypes.number.isRequired,
  units: PropTypes.any
}

export { TotalBottlesSaved, TotalCarbonSaved }
